import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'
import Img from "gatsby-image";
import { theme } from "../styles";
import styled from '@emotion/styled'
import { Wrapper } from '../components'
import website from '../../config/website'

import {
  CatalogItem,
  CatalogHeader,
} from '../components'
import {
  CatalogWrapper,
  ProductWrapper,
} from '../templates/catalogItemStyle'

const IndexWrapper = Wrapper.withComponent('main')
const Inner = styled.div`
  .gatsby-image-wrapper {
    max-width: 100% !important;
  }
  img {
    max-width: 100% !important;
    display: block;
  }
  p {
    margin: 1rem auto;
    font-family: "Lato" !important;
  }
  h2 {
    font-family: "Lato" !important;
    font-size: 2.4rem;
    margin: 0 0 0.5rem 0;
    font-weight: 500;
    color: #6d6d6d;
    text-transform: uppercase;
  }
  h3 {
    font-family: "Lato" !important;
    font-size: 1.4rem;
    margin: 0 0 2rem 0;
    font-weight: 300;
    color: #6d6d6d;
    text-transform: uppercase;
    span {
      font-weight: 500;
    }
    &.h2 {
      font-size: 1.8rem!important;
    }
  }
`;

const Head = styled.div`
  position: relative;
  margin-bottom: 1.35rem;
`;

const Hero = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-family: "Lato" !important;
    font-size: 1rem;
    line-height: 1.4rem;
    padding: 10rem 2rem 0 2rem;
    display: block;
  }
  h3.new {
    background:#fce477;
    color: #000;
    display: inline-block;
    border-radius: 5px;
    padding: 5px 10px;
    ${'' /* font-weight: bold; */}
    margin: 10px 0;
    font-size: 26px;
  }
  p.new {
    color: #283726;
    padding: 5px 0;
    margin: 0;
    a {
      font-weight: bold
    }
  }

  > div {
    width: 50%;
    &:first-of-type {
      padding-right: 1rem;
    }
    &:last-of-type {
      padding-left: 1rem;
    }
    p {
      margin-bottom: 1.35rem;
      font-size: 1.1rem;
      color: #6d6d6d;
    }
    .signature, .signature a {
      font-size: 16px;
    }
  }
  @media (max-width: ${theme.breakpoints.s}) {
    display: block;
    span {
      font-family: "Lato" !important;
      font-size: 1.2rem;
      line-height: 1.4rem;
      padding: 1rem 0;
      display: block;
    }
    > div {
      width: 100%;
      &:first-of-type {
        padding-right: 0;
      }
      &:last-of-type {
        padding-left: 0;
      }
      p {
        &:first-of-type {
          padding-top: 1.35rem;
        }
      }
    }
  }
`;

const SeptembreXXVI = ({ data }) => {

  const context = { slug: "exhibition", parent: "" };
  const artworks = data.artworks.nodes;
  console.log(data)
  
  return (
    <React.Fragment>
      <Helmet title={`Disch Rémy - La lettre`}>
        <link rel="stylesheet" type="text/css" href="https://unpkg.com/xzoom/dist/xzoom.css" media="all" />
        <script defer data-domain="dischr.com" src="https://plausible.io/js/script.js"></script>
      </Helmet>
      <CatalogHeader {...context} letter />
      <IndexWrapper id={website.skipNavId} style={{ paddingBottom: 0}}>
        <Inner>
          <Head>
            <Img
              fixed={data.banner.childImageSharp.fixed}
              placeholderStyle={{
                filter: "grayscale(100%) contrast(100%)",
                imageRendering: "pixelated",
                opacity: 0,
              }}
            />
            <Hero style={{ position: 'absolute', bottom: 0, left: '1rem' }}>
              <div style={{ width: '100%' }}>
                <h3 style={{ color: '#fff', opacity: 1, fontWeight: 'bold' }}>
                  <small>Septembre 2026</small><br />
                </h3>
              </div>
            </Hero>
          </Head>
          <Hero>
            <div style={{ width: '100%', paddingTop: '2rem', paddingBottom: '2rem', paddingLeft: 0, paddingRight: 0 }}>
              
              <p><strong>Loin du bruit, plus près des oiseaux</strong></p>

              <p>
                Un artiste, c'est quelqu'un qui est dévoré par ses émotions, et qui cherche sans cesse à les mettre en ordre pour les exprimer clairement. Sans la création, je ne suis pas grand-chose. Le temps ne revient jamais.
              </p>

              <p>
                Un an après mon exposition <i>Mélancoria</i>, dans ce monde qui tourne de plus en plus vite, avec le doute qui m'accompagne souvent, je reprends la route de la peinture.
              </p>

              <p>
                Je pars de Paris fin octobre, pour retrouver mes pinceaux et poursuivre ma recherche, loin du bruit, plus près des oiseaux.
              </p>

              <p>
                En France, la culture se sacrifie. Les budgets se coupent, les lieux ferment les uns après les autres, partout. Face à cela, je n'ai qu'une réponse : continuer à créer. C'est ma seule forme de résistance.
              </p>
              
              <p>
                Et puis, la connaissance, la culture, l'imagination… tout cela est infini. C'est là-dessus que je m'appuie.
              </p>

              <p>
                C'est aussi la raison pour laquelle je vous envoie cette nouvelle lettre, accompagnée de mes deux catalogues.
              </p>

              <p>
                Ma peinture a grandi avec vous. Elle s'est construite au fil des rencontres, au fil des premières toiles que certains d'entre vous ont choisies, puis des suivantes, parfois des années plus tard. Petit à petit, une histoire s'est créée.
              </p>

              <p>
                Aujourd'hui, vous êtes une centaine, à travers le monde, à vivre avec une partie de mon travail. Certaines de mes peintures sont accrochées chez vous depuis longtemps. Elles ont trouvé leur place dans vos maisons, dans vos vies, et continuent leur propre histoire.
              </p>

              <p>
                Je n'oublie pas cela. C'est aussi pour cette raison que j'ai envie de vous ouvrir à nouveau la porte de mon atelier et de vous permettre de participer à la suite de cette aventure.
              </p>

              <p>
                Les œuvres proposées dans les catalogues sont accessibles à -50 %. Cette offre est réservée à mes collectionneurs : vous êtes les seuls à pouvoir en profiter.
              </p>

              <p>
                Dans le catalogue consacré à <i>Mélancoria</i>, vous trouverez également des photographies de l'exposition. Vous pourrez ainsi constater que certaines œuvres possèdent un cadre : elles seront donc vendues avec leur cadre.
              </p>

              <p>
                Ces acquisitions vont concrètement m'aider à financer mon voyage, mon installation dans mon nouvel atelier et, surtout, à me donner le temps et l'espace nécessaires pour partir à la recherche d'un nouveau souffle dans ma peinture.
              </p>

              <p>
                Je ne sais pas encore exactement ce que je vais trouver au bout de cette route. Mais je sais que j'ai besoin de la prendre.
              </p>

              <p>
                Je reste bien sûr à votre disposition si vous avez des questions. N'hésitez pas à m'écrire, je serai ravi de vous répondre.
              </p>
              
              <p>
                Prenez soin de vous.
              </p>

              <p>
                Rémy
              </p>
              
            </div>
          </Hero>
        </Inner>
        {/* <hr /> */}
      </IndexWrapper>
      
      {/* <IndexWrapper id={website.skipNavId}>
        <Inner>
          <Hero>
            <div style={{ width: '100%', paddingLeft: 0, paddingRight: 0 }}>

              <div>
                <h3 className="new">Nouveau</h3>
                <p className="new">
                  - Découvrez <a className="regular-link" href="https://shop.dischr.com/" target="_blank">ma nouvelle boutique en ligne "Portraits"</a>,
                  rassemblant une sélection d'huiles sur papier à un prix très abordable. Bénéficiez pour l'ouverture de cette boutique d'une réduction exceptionnelle de 35% pendant 48h sur toutes les oeuvres avec le code "<strong>LE CERCLE</strong>".
                </p>
                <p className="new">
                  - Rejoignez <a className="regular-link" href="https://www.patreon.com/remy_disch" target="_blank">ma page Patreon</a> et accédez aux coulisses de mon cheminement de création tout en soutenant mon travail à partir de 5€ par mois.
                </p>
              </div>
              
            </div>
          </Hero>
        </Inner>
      </IndexWrapper> */}

      <IndexWrapper id={website.skipNavId}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          maxHeight: '600px',
          marginBottom: '2rem'
        }}>
          <div>
            <img style={{ maxHeight: '600px' }} src={data.photosIV.childImageSharp.fluid.srcWebp} />
          </div>
        </div>

        <div style={{
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          maxHeight: '600px',
          marginBottom: '2rem'
        }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{ padding: '0 1rem'}}><img style={{ maxHeight: '600px' }} src={data.photosIII.childImageSharp.fluid.srcWebp} /></div>
            <div style={{ padding: '0 1rem'}}><img style={{ maxHeight: '600px' }} src={data.photosI.childImageSharp.fluid.srcWebp} /></div>
          </div>
        </div>
      </IndexWrapper>
      
      <IndexWrapper id={website.skipNavId}>
        <Inner style={{ paddingTop: 0, paddingBottom: "3rem" }}>
          <Hero>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <a
                  href="https://www.dischr.com/catalog/2026"
                  target="_blank"
                  style={{
                    border: '1px solid #b4cfb0',
                    background: '#b4cfb0',
                    color: '#f2f2f2',
                    fontWeight: 'bold',
                    display: 'block',
                    padding: '.5rem 1rem',
                    borderRadius: '5px',
                    width: '16rem',
                    margin: '0 .5rem',
                    textAlign: 'center'
                  }}
                >
                  Catalogue 2026
                </a>

                <a
                  href="https://www.dischr.com/catalog/fonds-d-atelier/"
                  target="_blank"
                  style={{
                    border: '1px solid #b4cfb0',
                    background: '#b4cfb0',
                    color: '#f2f2f2',
                    fontWeight: 'bold',
                    display: 'block',
                    padding: '.5rem 1rem',
                    borderRadius: '5px',
                    width: '16rem',
                    margin: '0 .5rem',
                    textAlign: 'center'
                  }}
                >
                  Catalogue Fonds d'atelier
                </a>
              </div>

              <a
                href="mailto:dischr@gmail.com"
                style={{
                  fontSize: '14px',
                  textDecoration: 'underline',
                  display: 'block',
                  marginTop: '.5rem'
                }}
              >
                contact et informations
              </a>
            </div>
          </Hero>
        </Inner>
      </IndexWrapper>

      <ProductWrapper className={`banner picture`} 
        style={{ 
          backgroundImage: `url(${data.photosV.childImageSharp.fixed.srcWebp})`,
          backgroundPosition: 'center',
        }}
      />

      <IndexWrapper id={website.skipNavId}>
        <Inner>
          <Hero>
            <div style={{ width: '100%', paddingLeft: 0, paddingRight: 0 }}>
              <h3>Acquérir des oeuvres, soutenir mon travail</h3>

              <p>
                Si vous souhaitez acquérir et/ou vous informer de la disponibilité des oeuvres,
                je vous invite à me contacter directement en utilisant l'adresse email en pied de page.
              </p>
              
              <p>
                Vous pouvez également acquérir des oeuvres sur le site de mon partenaire <a className="regular-link" href="https://www.artsper.com/es/artistes-contemporains/france/102408/remy-disch" target="_blank">Artsper</a>
              </p>
              
              <p>
                ---
                <br /><h3 style={{ margin: 0, paddingBottom: "10px", paddingTop: "10px" }}>Rémy Disch</h3>
                <div className="signature">
                  Email : <a className="regular-link" href="mailto:dischr@gmail.com">dischr@gmail.com</a>
                  <br />Site internet : <a className="regular-link" href={`https://www.dischr.com`} target="_blank">www.dischr.com</a>
                  <br />Patreon : <a className="regular-link" href={`https://www.patreon.com/remy_disch`} target="_blank">patreon.com/remy_disch</a>
                </div>
              </p>
            </div>
          </Hero>
        </Inner>
      </IndexWrapper>
    </React.Fragment>
  );
};

export default SeptembreXXVI;

export const pageQuery = graphql`
  query SeptembreXXVI {
    banner: file(name: {eq: "homepage3"}) {
      childImageSharp {
        fixed(width: 1000, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
        fluid(maxWidth: 1000, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    photosI: file(name: {eq: "2"}) {
      childImageSharp {
        fixed(width: 1000, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
        fluid(maxWidth: 1000, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    photosII: file(name: {eq: "elles"}) {
      childImageSharp {
        fixed(width: 1000, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
        fluid(maxWidth: 1000, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    photosIII: file(name: {eq: "LENA"}) {
      childImageSharp {
        fixed(width: 1000, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
        fluid(maxWidth: 1000, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    photosIV: file(name: {eq: "Portraits"}) {
      childImageSharp {
        fixed(width: 1000, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
        fluid(maxWidth: 1000, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    photosV: file(name: {eq: "elles_Si"}) {
      childImageSharp {
        fixed(width: 1000, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
        fluid(maxWidth: 1000, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    affiche: file(name: {eq: "melancoria-affiche"}) {
      childImageSharp {
        fixed(width: 1000, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
        fluid(maxWidth: 1000, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    atelier: file(name: {eq: "atelier"}) {
      childImageSharp {
        fixed(width: 1000, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
        fluid(maxWidth: 1000, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    sub_banner: file(name: {eq: "Bandeau_revue"}) {
      childImageSharp {
        fixed(width: 1000, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
        fluid(maxWidth: 1000, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    og1: file(name: {eq: "ogzylone-10-11-2024-full"}) {
      publicURL
      childImageSharp {
        fixed(width: 600, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    og2: file(name: {eq: "revue-02-c"}) {
      publicURL
      childImageSharp {
        fixed(width: 800, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    artworks: allPrismicArtwork(
        filter: {
            prismicId: {
                in: [
                    "ZVeLNhIAACwAK99S", 
                    "ZUeTtRUAACwA13_k", 
                ]
            }
        }, 
        sort: {
            order: DESC, 
            fields: first_publication_date
        }) {
      nodes {
        prismicId
        data {
          meta_description
          meta_title
          title {
            text
          }
          drouot_estimate
          catalog_fullscreen
          type
          available
          on_demand
          price
          item {
            alt
            localFile {
              childImageSharp {
                fixed(height: 800, quality: 100) {
                  ...GatsbyImageSharpFixed_withWebp
                }
                fluid(maxWidth: 800, quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          cadre {
            alt
            localFile {
              childImageSharp {
                fixed(height: 800, quality: 100) {
                  ...GatsbyImageSharpFixed_withWebp
                }
                fluid(maxWidth: 800, quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          image_hd {
            localFile {
              childImageSharp {
                original {
                  height
                  src
                  width
                }
              }
            }
          }
          categories {
            ... on PrismicArtworkDataCategories {
              category {
                uid,
                document {
                  data {
                    name
                  }
                }
              }
            }
          }
          year {
            ... on PrismicArtworkDataYear {
              uid
            }
          }
        }
      }
    }
  }
`
